var ezdia;
(function (ezdia) {
    var NAME = 'htmlEditor';
    var TYPE = 'htmlEditor';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var deleteConfirmId = 'ez-tinymce-comment-delete-confirm';
    var commentlocalStorage = 'ez.tinymce.comment.localStorage.';
    var ltSetHighlight = {
        misspelling: 'hlr1',
        grammar: 'hlg1',
        typographical: 'hlb1',
        style: 'hln1',
        duplication: 'hlo1',
        inconsistency: 'hlp1',
        other: 'hly1'
    };
    var ltLoadingCls = 'lt-in-progress';
    var ltLoadingBodyCls = 'lt-in-progress-body';
    var DEFAULT = {
        defaultContent: null,
        readonly: false,
        wordsum: null,
        keywords: null,
        badContent: null,
        isIce: false,
        countTemplate: ezdia.templates.tinymce.countTemplate,
        alertTemplate: ezdia.templates.tinymce.alertTemplate,
        alertMsgTemplate: ezdia.templates.tinymce.alertMsgTemplate,
        keywordTemplate: ezdia.templates.tinymce.keywordTemplate,
        uploadTemplate: ezdia.templates.tinymce.uploadTemplate,
        toggleTemplate: ezdia.templates.tinymce.toggleTemplate,
        commentTemplate: ezdia.templates.tinymce.commentTemplate,
        commentListTemplate: ezdia.templates.tinymce.commentListTemplate,
        ltContextMenuTemplate: ezdia.templates.tinymce.ltContextMenuTemplate,
        ltEditorLoading: ezdia.templates.tinymce.ltEditorLoading,
        blockElements: [
            'p',
            'div',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'ol',
            'ul',
            'li',
            'address',
            'pre',
            'table',
            'dl',
            'blockquote',
            'fieldset',
            'form',
            'hr'
        ],
        wordCountre: /[\w\u2019\x27\-\u00C0-\u1FFF]+/g,
        wordCleanre: /[.(),;:!?%#$?\x27\x22_+=\\\/\-]*/g,
        inputParent: '[data-row="input"]',
        totalWordParent: '[data-row="wordcount"]',
        updateRate: 100,
        keywordsUpdateRate: 100,
        mswordMessage: '',
        toggle: false,
        commentTempId: 'edCommentTempId'
    };
    var classes = {
        countClass: 'ez-editor-count',
        countClassWarning: 'ez-editor-count-warning',
        countClassSuccess: 'ez-editor-count-success',
        countClassSelected: 'ez-editor-count-selected',
        countTotalClassWarning: 'ez-wordcount-field-warning',
        countTotalClassSuccess: 'ez-wordcount-field-success',
        commentCls: 'ed-comments'
    };
    function getCommentId(event) {
        var target = event.target;
        var rowid = target.dataset.rowid;
        return rowid;
    }
    function toggleEditCommentBox(id, event) {
        var rowid = id || getCommentId(event);
        $("#editBlock" + rowid).toggle();
        $("#viewBlock" + rowid).toggle();
    }
    function updateCommentRowView(id, comment) {
        $("#commentViewText" + id).html(comment);
        toggleEditCommentBox(id);
    }
    function posCommentPopup(ed, tempId) {
        if (ed.inline) {
            var element = tempId instanceof jQuery ? tempId : $("#" + tempId);
            var itemOffset = element.offset();
            var leftPos = itemOffset.left + element.outerWidth() / 2;
            // var windowScroll = $('body').scrollTop();
            return {
                top: itemOffset.top,
                left: leftPos
            };
        }
        var ifrm = $("#" + ed.id + "_ifr")[0];
        var iframeWindow = ifrm.contentWindow || ifrm.contentDocument;
        // var windowScroll = $('body').scrollTop();
        var container = $(ed.getContentAreaContainer());
        var body = $(ed.getBody());
        var item = tempId instanceof jQuery ? tempId : body.find("#" + tempId);
        var ifrPos = container.offset();
        var ifrHeight = container.height();
        var itemPos = item.offset();
        var left = ifrPos.left + itemPos.left + item.outerWidth() / 2;
        var scrollPos = iframeWindow.scrollY || iframeWindow.scrollTop || 0;
        var scrollHeight = ifrHeight + scrollPos;
        if (itemPos.top < scrollPos || itemPos.top > scrollHeight) {
            scrollPos = iframeWindow.scrollY || iframeWindow.scrollTop || 0;
        }
        return {
            top: ifrPos.top + itemPos.top - scrollPos,
            left: left
        };
    }
    function getCommentList(id) {
        var list = '';
        var data = "&commentThreadId=" + (id === 'edCommentTempId' ? '' : id);
        $.ajax({
            type: 'POST',
            url: 'fetchComments.htm',
            data: data,
            dataType: 'json',
            async: false,
            success: function (response) {
                list = response;
            },
            error: function (response) {
                list = response;
            }
        });
        return list;
    }
    function getRemoveConfirmationBox() {
        var wrapper = $('#ez-comment-remove-confirmation');
        if (!wrapper.length) {
            var div = $('<div>', {
                id: 'ez-comment-remove-confirmation'
            });
            $('body').append(div);
            wrapper = $('#ez-comment-remove-confirmation');
        }
        return wrapper;
    }
    function insertAt(mystr, CharToInsert, Position) {
        return mystr.slice(0, Position) + CharToInsert + mystr.slice(Position);
    }
    function ltText(str) {
        var encodeURIComponentStr = encodeURIComponent(str);
        var reg = /\%EF\%BB\%BF/g;
        return decodeURIComponent(encodeURIComponentStr.replace(reg, ''));
    }
    var HtmlEditor = /** @class */ (function () {
        function HtmlEditor(elem, options) {
            this.elem = elem;
            this.removeIceDeletedContent = function (contentStr) {
                var content = contentStr;
                var context = $('<div>', {
                    html: content
                });
                var deletedChar = context.find('.del');
                if (deletedChar.length) {
                    deletedChar.each(function each() {
                        $(this).remove();
                    });
                    content = context.html();
                }
                return content;
            };
            this.ltClearHighlighter = function (content) {
                var temphtml = content.replace(/<span class="lt-highlight(?:-remove|)[\w \-]+?" data-hid="[0-9]+" data-word="[a-zA-Z0-9\/=+]+" data-rule="[a-zA-Z0-9_]+">(.*?)<\/span>/g, function (match, p1) { return p1; });
                return temphtml;
            };
            this.init(options);
        }
        Object.defineProperty(HtmlEditor.prototype, "Defaults", {
            // eslint-disable-next-line class-methods-use-this
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        HtmlEditor.prototype.updateCharCount = function (content) {
            var _this = this;
            var count = 0;
            var charcount = this.options.charcount;
            if (this.charcountActive) {
                return;
            }
            this.charcountActive = true;
            count = this.getCharCount(content);
            this.charcountElem.html(count);
            if ((charcount.min || charcount.max) && !this.selectedCountActive) {
                this.checkEditorCountStatus(charcount, count, 'char');
            }
            setTimeout(function () {
                _this.charcountActive = false;
            }, this.options.updateRate);
        };
        HtmlEditor.prototype.updateWordCount = function (content) {
            var _this = this;
            var count = 0;
            var ed = this.editor || {};
            var wordcount = this.options.wordcount;
            if (this.wordcountActive) {
                return;
            }
            this.wordcountActive = true;
            count = this.getWordCount(content);
            this.wordcountElem.html(count);
            if (this.wcField && this.wcField.length) {
                this.wcField.val(count);
            }
            if ((wordcount.min || wordcount.max) &&
                (!this.selectedCountActive || ed.keyCode === 8)) {
                this.checkEditorCountStatus(wordcount, count, 'word');
            }
            ed.keyCode = null;
            setTimeout(function () {
                _this.wordcountActive = false;
            }, this.options.updateRate);
        };
        HtmlEditor.prototype.updateSelectedCount = function (active, content) {
            var _a = this.options, countRow = _a.countRow, wordcount = _a.wordcount, charcount = _a.charcount;
            var row = this.countRow || $(countRow);
            this.selectedCountActive = true;
            if (!wordcount.disable) {
                this.updateWordCount(content);
            }
            if (!charcount.disable) {
                this.updateCharCount(content);
            }
            if (active) {
                row.addClass(classes.countClassSelected);
            }
            else {
                this.selectedCountActive = false;
                row.removeClass(classes.countClassSelected);
            }
        };
        HtmlEditor.prototype.updateKeywordsCount = function () {
            var _this = this;
            var self = this;
            var ed = tinymce.get(this.id);
            var count = 0;
            var idPrefix = "#ez-" + this.id + "-";
            var content = this.value || '';
            if (ed || this.options.inlineContainer) {
                content =
                    this.getContent(false, {
                        format: 'text'
                    }) || '';
            }
            if (this.keywordsCountActive) {
                return;
            }
            this.keywordsCountActive = true;
            $.each(this.keywords, function (key, mval) {
                var tcount = 0;
                count = 0;
                $.each(mval, function (i, value) {
                    if (value && content) {
                        count = _this.getKeywordsCount(key, value, content, i);
                    }
                    $(idPrefix + key + i)
                        .find('[data-type="count"]')
                        .text(count);
                    tcount += count;
                });
                $("#" + self.name + "_" + key + "_kc").val(tcount);
            });
            setTimeout(function () {
                self.keywordsCountActive = false;
            }, self.options.keywordsUpdateRate);
        };
        HtmlEditor.prototype.clearBadContent = function () {
            var ed = this.editor;
            var contect = ed.getContent();
            $.each(this.options.badContent, function (i, obj) {
                var re = new RegExp(obj.regex, 'g');
                contect = contect.replace(re, obj.replacement);
            });
            ed.setContent(contect);
        };
        HtmlEditor.prototype.uploadContent = function (panel) {
            var ed = this.editor;
            var file = $('#ez-editor-upload-file').val();
            if (!file) {
                $('#ez-editor-file-upload-msg')
                    .show()
                    .html('Please choose a file type to upload a file.')
                    .addClass('bg-danger');
                return;
            }
            $('#ez-editor-file-upload-msg, #ez-editor-file-upload-form').hide();
            var top = $('body').scrollTop();
            var loading = $('#ez-editor-file-upload-loading').show();
            $('#ez-editor-file-upload-form')
                .ajaxForm({
                url: 'docToHtmlConverter.htm',
                type: 'POST',
                dataType: 'text',
                success: function (response) {
                    var index = response.indexOf('<body>') + 6;
                    var len = response.indexOf('</body>');
                    var content = response.substring(index, len);
                    ed.setContent(content);
                    ed.focus();
                    panel.dialog('close');
                    $('body').scrollTop(top);
                },
                error: function () {
                    $('#ez-editor-file-upload-form-wrapper').html('Error Uploading File.');
                    $('#ez-editor-file-upload-btn').hide();
                    loading.hide();
                }
            })
                .submit();
        };
        HtmlEditor.prototype.msWordContent = function () {
            var ed = this.editor;
            var content = ed.getContent();
            var type = 'msword';
            if (/class="?Mso|style="[^"]*\bmso-|w:WordDocument/i.test(content) &&
                !this.alertActive[type]) {
                this.showAlert(type, { message: this.options.mswordMessage });
            }
        };
        HtmlEditor.prototype.setHeight = function () {
            var _this = this;
            var ed = this.editor;
            var ifrm = $("#" + ed.id + "_ifr");
            $(window).on('resize', function () {
                if (!_this.isEdResize) {
                    _this.isEdResize = true;
                    setTimeout(function () {
                        _this.isEdResize = false;
                        if (ed) {
                            var body = ed.getBody();
                            var heights = $(ed.getBody())[0].scrollHeight;
                            ifrm.css('height', heights);
                            body.style.padding = 0;
                            body.style.background = 'transparent';
                        }
                    }, 1000);
                }
            });
        };
        HtmlEditor.prototype.updateWordsum = function () {
            var _this = this;
            var wordsum = this.options.wordsum;
            var count = 0;
            $.each(wordsum, function (i, obj) {
                var inputs = $("#" + obj.id);
                count = _this.getWordsum(inputs);
                $("#ez-wordcount-" + obj.id).text(count);
                inputs.val(count);
                if (obj.count) {
                    _this.checkWordsumStatus(inputs, obj.count, count, 'total');
                }
            });
        };
        HtmlEditor.prototype.toggle = function () {
            var ed = this.editor;
            var elem = this.id;
            var height = ed.settings.height;
            var template = this.options.toggleTemplate;
            var editor = $("#" + elem).css('height', height);
            var context = {
                id: "ez-tab-" + elem
            };
            if (this.version === 3) {
                editor.before(template(context));
            }
            else {
                $(this.editor.getContainer()).before(template(context));
            }
            $("#" + context.id).on('click', 'a', function each() {
                $(this).addClass('active').siblings().removeClass('active');
                tinymce.execCommand('mceToggleEditor', false, elem);
            });
            $("#" + elem).on('blur', function each() {
                if (this.offsetParent !== null) {
                    var content = this.value;
                    ed.setContent(content);
                }
            });
        };
        HtmlEditor.prototype.comment = function (type, itemId) {
            switch (type) {
                case 'remove':
                    this.options.clearAll = false;
                    this.removeConfirmation();
                    break;
                case 'removeAll':
                    this.options.clearAll = true;
                    this.removeConfirmation();
                    break;
                case 'list':
                    this.commentPopup(itemId);
                    break;
                case 'close':
                    this.closeComment();
                    break;
                default:
                    this.addComment();
                    break;
            }
        };
        HtmlEditor.prototype.languagetool = function () {
            var _this = this;
            var self = this;
            var ed = this.editor;
            this.cache.inputContainer
                .addClass(ltLoadingCls)
                .find('a.abortlt')
                .off('click')
                .on('click', function () {
                _this.abortlt();
            });
            ed.setMode('readonly');
            ed.selection.collapse();
            ed.execCommand('mceInsertContent', false, '<span id="lt-bookmark"></span>');
            var text = this.getltText();
            if (!text) {
                this.abortlt();
                return;
            }
            var data = {
                disabledRules: 'WHITESPACE_RULE',
                language: 'en-US',
                allowIncompleteResults: true,
                text: text
            };
            if (!ed.inline) {
                ed.iframeElement.blur();
            }
            else {
                $('body').addClass(ltLoadingBodyCls);
            }
            $.ajax({
                type: 'POST',
                url: 'checkText.htm?',
                data: data,
                dataType: 'json',
                success: function (resObj) {
                    if (ed.settings.lt_isdirty) {
                        return;
                    }
                    self.cache.lt.matches = resObj.matches;
                    self.ltErrors({
                        text: text,
                        res: resObj
                    });
                    self.ltSetContent();
                    self.abortlt();
                }
            });
            $(this.editor.getBody())
                .off('.lt.open.context.menu')
                .on('click.lt.open.context.menu', '.lt-highlight', function each(e) {
                if ($(e.target).hasClass(classes.commentCls)) {
                    return;
                }
                if (self.cache.comment.popup) {
                    self.closeComment(true);
                }
                e.stopPropagation();
                self.ltContextMenu(this);
            });
        };
        HtmlEditor.prototype.createLtLoading = function (inline) {
            var template = this.options.ltEditorLoading;
            this.cache.inputContainer.append(template({
                inline: inline || false
            }));
        };
        HtmlEditor.prototype.clean = function () {
            var ed = this.editor;
            if (ed && ed.dom) {
                ed.dom.remove(ed.dom.select('.gr_spell.gr_inline_cards'), true);
                if (this.options.lt) {
                    ed.dom.remove(ed.dom.select('.lt-highlight'), true);
                }
                if (this.options.keywords) {
                    ed.dom.remove(ed.dom.select('.highlight-keyword'), true);
                }
            }
        };
        HtmlEditor.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        HtmlEditor.prototype.getCache = function () {
            return {
                comment: {
                    close: "ez-comment-close-" + this.id,
                    save: "ez-save-comment-" + this.id
                },
                lt: {},
                inputContainer: this.$elem.closest(this.options.inputParent)
            };
        };
        HtmlEditor.prototype.init = function (options) {
            this.id = this.elem.id;
            this.name = this.elem.name;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.cache = this.getCache();
            this.editor = tinymce.get(this.id);
            this.alertActive = {};
            this.alertActiveType = {};
            this.countLimit = {};
            this.counts = {};
            this.version = tinymce.majorVersion;
            this.render();
        };
        HtmlEditor.prototype.render = function () {
            var _a = this.options, readonly = _a.readonly, wordcount = _a.wordcount, charcount = _a.charcount, lt = _a.lt, keywords = _a.keywords, toggle = _a.toggle;
            if (readonly && !this.editor.settings.readonlyHeight) {
                this.setHeight();
            }
            else if (!readonly) {
                if (!wordcount.disable) {
                    this.createWordCount();
                }
                if (!charcount.disable) {
                    this.createCharCount();
                }
                if (!this.options.inline && lt) {
                    this.createLtLoading();
                }
                if (lt && $.ezdia.isLocalStorageEnable) {
                    this.ltIgnoreListSetup();
                }
            }
            if (keywords) {
                this.createKeywords();
            }
            if (toggle) {
                this.toggle();
            }
            this.createWordCountHiddenField();
        };
        HtmlEditor.prototype.createWordCountHiddenField = function () {
            var fieldName = this.options.field_name;
            if (!fieldName) {
                return;
            }
            var wcField = $("[name=" + fieldName + "_wc]");
            if (!wcField.length) {
                var input = "<input type=\"hidden\" value=\"0\" name=\"" + fieldName + "_wc\">";
                $("[name=" + fieldName + "]").after(input);
                wcField = $("[name=" + fieldName + "_wc]");
            }
            this.wcField = wcField;
        };
        HtmlEditor.prototype.keywordClick = function (e) {
            var self = this;
            var elem = $(e.currentTarget);
            var name = elem.data('name');
            var index = elem.data('index');
            var isInline = this.options.inlineContainer;
            var content = this.getContent(false, {
                format: 'raw',
                ez_keyword: isInline
            });
            var last = this.highlightKeywordActive;
            if (!content || !this.keywordsQuery[name + index]) {
                return;
            }
            if (this.highlightKeywordActive) {
                this.unhighlightKeyword.call(this);
                content = this.getContent(false, {
                    format: 'raw',
                    ez_keyword: isInline
                });
            }
            if (last !== name + index) {
                if (this.options.inlineContentContainer) {
                    $.each(content, function each() {
                        var wrap = $(this);
                        var incontent = wrap.html();
                        self.highlightKeyword(name, incontent, index, wrap);
                    });
                }
                else {
                    this.highlightKeyword(name, content, index);
                }
            }
        };
        HtmlEditor.prototype.createCountWrapper = function () {
            var id = "ez-editor-count-" + this.id;
            var row = this.options.countRow;
            var elem = $("#" + id);
            if (!elem.length) {
                var div = $('<div>', {
                    id: id,
                    class: classes.countClass
                });
                $(row).append(div);
                elem = $("#" + id);
                this.countRow = elem;
            }
            return elem;
        };
        HtmlEditor.prototype.createWordCount = function () {
            var _a = this.options, wordcount = _a.wordcount, defaultContent = _a.defaultContent;
            var row = this.createCountWrapper();
            var id = wordcount.id;
            var wordId = "wordcount-" + this.id;
            var content = defaultContent;
            var countWrapper = null;
            var context = null;
            if (!id) {
                if (row) {
                    countWrapper = row;
                }
                else {
                    return;
                }
            }
            else {
                countWrapper = $("#" + id);
            }
            context = this.options.countTemplate({
                label: 'Words:',
                id: wordId,
                obj: wordcount,
                count: this.getWordCount(content)
            });
            countWrapper.append(context);
            this.wordcountElem = $("#ez-editor-count-" + wordId);
            this.wordcountActive = false;
        };
        HtmlEditor.prototype.createCharCount = function () {
            var _a = this.options, charcount = _a.charcount, defaultContent = _a.defaultContent;
            var row = this.createCountWrapper();
            var id = charcount.id;
            var charId = "charcount-" + this.id;
            var content = defaultContent;
            var context = null;
            var countWrapper = null;
            if (!id) {
                if (row) {
                    countWrapper = row;
                }
                else {
                    return;
                }
            }
            else {
                countWrapper = $("#" + id);
            }
            context = this.options.countTemplate({
                label: 'Character:',
                id: charId,
                obj: charcount,
                count: this.getCharCount(content)
            });
            countWrapper.append(context);
            this.charcountElem = $("#ez-editor-count-" + charId);
            this.charcountActive = false;
        };
        HtmlEditor.prototype.getCharCount = function (contentStr) {
            var _a = this.options, charcount = _a.charcount, isIce = _a.isIce;
            var ignoreHtml = charcount.ignore_html, weightage = charcount.weightage;
            var count = 0;
            var contentLen = 0;
            var weightageCount = 0;
            var htmlElemCount = 0;
            var content = contentStr;
            if (!content) {
                content = this.getContent(true);
                if (!content || content === '%MCEPASTEBIN%') {
                    content = this.getContent(false);
                }
            }
            if (content) {
                content = isIce ? this.removeIceDeletedContent(content) : content;
                if (ignoreHtml) {
                    htmlElemCount = this.getHtmlElementsCount(content);
                    var contentDiv = $('<div>', {
                        html: content
                    });
                    content = contentDiv.text();
                }
                if (weightage) {
                    // eslint-disable-next-line array-callback-return
                    Object.keys(weightage).map(function (key) {
                        var rgx = new RegExp(key, 'g');
                        var totalCount = (content.match(rgx) || []).length;
                        var buffer = weightage[key];
                        weightageCount += buffer * totalCount - totalCount;
                    });
                }
                if (this.editor && this.editor.settings.text_encoder) {
                    contentLen = new TextEncoder().encode(content).length;
                }
                else {
                    contentLen = content.length;
                }
                count = htmlElemCount + weightageCount + contentLen;
            }
            this.counts.charcount = count;
            return count;
        };
        HtmlEditor.prototype.getHtmlElementsCount = function (contect) {
            var textContent = contect.toLowerCase();
            var content = $('<div>', { html: textContent });
            var htmlItems = content.find('*').length;
            var count = 0;
            if (htmlItems !== this.htmlElements) {
                this.htmlElements = htmlItems;
                $.each(this.options.blockElements, function (i, elements) {
                    count += content.find(elements).length;
                });
                if (count) {
                    count--;
                }
                count += content.find('br').length;
            }
            return count;
        };
        HtmlEditor.prototype.getWordCount = function (contentStr) {
            var content = contentStr;
            var _a = this.options, wordCleanre = _a.wordCleanre, wordCountre = _a.wordCountre;
            var count = 0;
            var arr = [];
            if (!content) {
                content = this.getContent(true, {
                    format: 'raw'
                });
                if (!content || content === '%MCEPASTEBIN%') {
                    content = this.getContent(false, {
                        format: 'raw'
                    });
                }
            }
            if (content) {
                content = this.removeIceDeletedContent(content);
                content = content.replace(/\.\.\./g, ' '); // convert ellipses to spaces
                content = content
                    .replace(/<.[^<>]*?>/g, ' ')
                    .replace(/&nbsp;|&#160;/gi, ' '); // remove html tags and space chars
                // deal with html entities
                content = content
                    .replace(/(\w+)(&.+?;)+(\w+)/, '$1$3')
                    .replace(/&.+?;/g, ' ');
                content = content.replace(wordCleanre, ''); // remove numbers and punctuation
                arr = content.match(wordCountre);
                if (arr) {
                    count = arr.length;
                }
            }
            this.counts.wordcount = count;
            return count;
        };
        HtmlEditor.prototype.checkCount = function (obj, count, type, inputs) {
            var error = false;
            if (obj.min) {
                if (obj.min.limit && obj.min.limit.count > count) {
                    if (inputs) {
                        inputs.data('limitActive', true);
                    }
                    else {
                        this.countLimit[type] = true;
                    }
                    error = $.extend(obj.min, { js_type: 'limit_min' });
                }
                else if (obj.min.count > count) {
                    error = $.extend(obj.min, { js_type: 'min' });
                }
            }
            if (obj.max && !error) {
                if (obj.max.limit && obj.max.limit.count < count) {
                    if (inputs) {
                        inputs.data('limitActive', true);
                    }
                    else {
                        this.countLimit[type] = true;
                    }
                    error = $.extend(obj.max, { js_type: 'limit_max' });
                }
                else if (obj.max.count < count) {
                    error = $.extend(obj.max, { js_type: 'max' });
                }
            }
            return error;
        };
        HtmlEditor.prototype.checkWordsumStatus = function (inputs, obj, count, type) {
            inputs.data('limit', false);
            var elem = inputs.parents(this.options.totalWordParent);
            var error = this.checkCount(obj, count, type, inputs);
            var alertActive = inputs.data('alertActive');
            var limitActive = inputs.data('limitActive');
            var activeType = this.alertActiveType[type];
            if (error) {
                elem.addClass(classes.countTotalClassWarning);
                elem.removeClass(classes.countTotalClassSuccess);
            }
            else {
                elem.addClass(classes.countTotalClassSuccess);
                elem.removeClass(classes.countTotalClassWarning);
            }
            if (limitActive && !obj.limitAlert) {
                this.hideAlert(type, inputs);
                // eslint-disable-next-line no-param-reassign
                obj.limitAlert = true;
                this.showAlert(type, error, inputs);
                alertActive = inputs.data('alertActive');
            }
            else if (!limitActive && obj.limitAlert) {
                this.hideAlert(type, inputs);
                this.countLimit[type] = false;
                // eslint-disable-next-line no-param-reassign
                obj.limitAlert = false;
            }
            if (activeType && activeType !== error.js_type) {
                this.hideAlert(type);
            }
            if (alertActive && !error) {
                this.hideAlert(type, inputs);
            }
            else if (!alertActive && error) {
                this.showAlert(type, error, inputs);
            }
        };
        HtmlEditor.prototype.checkEditorCountStatus = function (obj, count, type) {
            this.countLimit[type] = false;
            var elem = type === 'char' ? this.charcountElem : this.wordcountElem;
            var error = this.checkCount(obj, count, type);
            var activeType = this.alertActiveType[type];
            if (error) {
                elem.addClass(classes.countClassWarning);
                elem.removeClass(classes.countClassSuccess);
            }
            else {
                elem.addClass(classes.countClassSuccess);
                elem.removeClass(classes.countClassWarning);
            }
            if (this.countLimit[type] && !obj.limitAlert) {
                this.hideAlert(type);
                // eslint-disable-next-line no-param-reassign
                obj.limitAlert = true;
                this.showAlert(type, error);
            }
            else if (!this.countLimit[type] && obj.limitAlert) {
                this.hideAlert(type);
                this.countLimit[type] = false;
                // eslint-disable-next-line no-param-reassign
                obj.limitAlert = false;
            }
            if (activeType && activeType !== error.js_type) {
                this.hideAlert(type);
            }
            if (!this.alertActive[type] && error) {
                this.showAlert(type, error);
            }
            else if (this.alertActive[type] && !error) {
                this.hideAlert(type);
            }
        };
        HtmlEditor.prototype.showAlert = function (type, obj, inputs) {
            var name = null;
            var id = null;
            var elem = null;
            var template = null;
            var parent = null;
            var content = null;
            var limit = null;
            var context = null;
            if (inputs) {
                inputs.data('alertActive', true);
                name = inputs.attr('id');
                id = "ez-total-wordcount-alert-" + name;
                limit = inputs.data('limitActive');
                parent = inputs.parents(this.options.inputParent);
            }
            else {
                this.alertActive[type] = true;
                this.alertActiveType[type] = obj.js_type;
                name = this.id;
                id = "ez-editor-alert-" + name;
                limit = this.countLimit[type];
                parent = this.$elem.parent(this.options.inputParent);
            }
            context = {
                type: type,
                message: limit ? obj.limit.message : obj.message
            };
            elem = $("#" + id);
            if (!elem.length) {
                template = this.options.alertTemplate;
                context.id = id;
                content = template(context);
                parent.prepend(content);
            }
            else {
                template = this.options.alertMsgTemplate;
                content = template(context);
                elem.append(content);
            }
            if (!elem.is(':visible')) {
                elem.show();
            }
            template = this.options.alertMsgTemplate;
            context.msgId = "ez-editor-alert-field-" + type + "-" + name;
            context.name = name;
            context.label = $("#" + name + "_label").text();
            var msgEl = $('#edWarnings').find("#" + context.msgId);
            if (!msgEl.length) {
                content = template(context);
                if (obj.type === 'error' || limit) {
                    $('#edErrors').show().append(content);
                    $('#submitBtn').attr('disabled', 'disabled');
                }
                else {
                    $('#edWarnings').show().append(content);
                }
            }
            $("#" + context.msgId).on('click', '[data-click]', function () {
                $.ezdia.scrollTo(parent);
            });
        };
        HtmlEditor.prototype.hideAlert = function (type, inputs) {
            var name = null;
            var id = null;
            var elem = null;
            if (inputs) {
                inputs.data('alertActive', false);
                name = inputs.attr('id');
                id = "ez-total-wordcount-alert-" + name;
            }
            else {
                this.alertActive[type] = false;
                this.alertActiveType[type] = false;
                name = this.id;
                id = "ez-editor-alert-" + name;
            }
            elem = $("#" + id);
            elem.find("[data-message=\"" + type + "\"]").remove();
            if (!elem.find('[data-message]').length) {
                elem.hide();
            }
            id = $("#ez-editor-alert-field-" + type + "-" + name);
            elem = id.parent();
            id.remove();
            if (elem.html() && !elem.html().trim()) {
                if (elem.attr('id') === 'edErrors') {
                    $('#submitBtn').removeAttr('disabled');
                }
                elem.hide();
            }
        };
        HtmlEditor.prototype.createKeywords = function () {
            var _a;
            var self = this;
            var selectedIds = ezdia.util.getSelectedGridItemsIds();
            if (selectedIds.length !== 1) {
                return;
            }
            var valueJSON;
            var _b = __read(selectedIds, 1), selectedId = _b[0];
            var gridData = ((_a = ezdia.config.GRID_DATA) === null || _a === void 0 ? void 0 : _a.grid[selectedId]) || {};
            var _c = this.options, keywords = _c.keywords, template = _c.keywordTemplate;
            var elem = this.id;
            var idPrefix = "ez-" + elem + "-";
            var context = {
                id: "ez-keywords-well-" + elem
            };
            var arr = [];
            var content = '';
            this.keywords = {};
            $.each(keywords, function (i, name) {
                var e_1, _a;
                var id = $("[name=" + name + "]");
                if (!id.length) {
                    id = $("#" + name);
                }
                var isinput = id.is('input') || id.is('textarea');
                var value = '';
                var display = false;
                if (isinput) {
                    value = id.val();
                    id.change(function each() {
                        self.keywordChangeupdate(name, this.value);
                    });
                }
                else {
                    value = gridData[name] || '';
                }
                try {
                    valueJSON = JSON.parse(value);
                }
                catch (e) {
                    console.log("Not an object");
                }
                finally {
                }
                if (valueJSON) {
                    display = true;
                    var counter = 0;
                    self.keywords[name] = [];
                    try {
                        for (var _b = __values(Object.entries(valueJSON)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
                            self.keywords[name].push(val["keyword"]);
                            arr.push({
                                id: idPrefix + name + counter,
                                name: name,
                                label: val["keyword"],
                                count: 0,
                                display: display,
                                index: counter
                            });
                            counter++;
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else if (value) {
                    display = true;
                    value = value.trim().split(',');
                    self.keywords[name] = value;
                    $.each(value, function (j, mval) {
                        arr.push({
                            id: idPrefix + name + j,
                            name: name,
                            label: mval,
                            count: 0,
                            display: display,
                            index: j
                        });
                    });
                }
            });
            context.keywords = arr;
            content = template(context);
            if (this.options.inlineContainer) {
                this.options.inlineContainer.append(content);
            }
            else {
                $("#" + this.id).after(content);
            }
            this.keywordsQuery = {};
            this.cache.keywordsWell = $("#" + context.id);
            this.cache.keywordsWell.on("click.ez" + TYPE, 'a', $.proxy(this.keywordClick, this));
        };
        HtmlEditor.prototype.keywordChangeupdate = function (name, valueStr) {
            var value = valueStr;
            var self = this;
            var content = this.getContent(false, {
                format: 'text'
            }) || '';
            var keypre = "ez-" + this.id + "-" + name;
            var idPrefix = "ez-" + this.id + "-";
            var template = this.options.keywordTemplate;
            var well = this.cache.keywordsWell;
            var context = '';
            $("[id^=" + keypre).remove();
            if (value) {
                var arr_1 = [];
                value = value.split(',');
                $.each(value, function (i, mval) {
                    arr_1.push({
                        id: idPrefix + name + i,
                        name: name,
                        label: mval,
                        count: content ? self.getKeywordsCount(name, mval, content, i) : 0,
                        display: true,
                        index: i
                    });
                });
                context = template({ keywords: arr_1 });
                context = $(context).html();
                well.append(context).show();
                this.keywords[name] = value;
            }
            else {
                this.keywords[name] = [];
                well.hide();
            }
        };
        HtmlEditor.prototype.getKeywordsCount = function (name, keywordStr, content, index) {
            var keyword = keywordStr;
            var count = 0;
            var query = null;
            var keywords = [];
            keyword = keyword.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
            keyword = keyword.trim().replace(/ /g, '[&nbsp;|\\s]+');
            query = new RegExp("\\b" + keyword + "\\b", 'ig');
            keywords = content.match(query);
            if (keywords) {
                count = keywords.length;
                this.keywordsQuery[name + index] = query;
            }
            return count;
        };
        HtmlEditor.prototype.highlightKeyword = function (name, content, index, inlineEditor) {
            var _this = this;
            var ed = this.editor;
            var query = this.keywordsQuery[name + index];
            var mat = '';
            var ex = 0;
            var hContent = content;
            // tslint:disable-next-line:no-conditional-assignment
            while ((mat = query.exec(content)) !== null) {
                var qstr = mat[0];
                var indexOf = mat.index + ex;
                var start = indexOf + qstr.length;
                var subContent = '';
                var lt = 0;
                var gt = 0;
                subContent = hContent.substring(start);
                lt = subContent.search(/</);
                gt = subContent.search(/>/);
                if (lt <= gt) {
                    hContent = hContent.slice(0, indexOf) + "<span class=\"highlight-keyword\">" + qstr + "</span>" + subContent;
                    ex += 39;
                }
            }
            this.highlightKeywordActive = name + index;
            if (inlineEditor) {
                inlineEditor.html(hContent);
                this.options.inlineContentContainer.on('click.ez.unhighlightKeyword', function () {
                    _this.unhighlightKeyword();
                });
            }
            else {
                ed.setContent(hContent);
                $(ed.getBody()).on("keypress.ez" + TYPE, function () {
                    _this.unhighlightKeyword();
                });
            }
        };
        HtmlEditor.prototype.unhighlightKeyword = function () {
            var removeItem = '.highlight-keyword';
            if (this.options.inlineContentContainer) {
                this.options.inlineContentContainer
                    .find(removeItem)
                    .contents()
                    .unwrap();
                this.options.inlineContentContainer.off('.ez.unhighlightKeyword');
            }
            else {
                var ed = this.editor;
                ed.dom.remove(ed.dom.select(removeItem), true);
                $(ed.getBody()).off(".ez" + TYPE);
            }
            this.highlightKeywordActive = null;
        };
        HtmlEditor.prototype.createUploadPanel = function () {
            var self = this;
            var id = 'ez-editor-file-upload-wrapper';
            var elem = $("#" + id);
            if (!elem.length) {
                var divs = $('<div>', {
                    id: id
                });
                $('body').append(divs);
                elem = $("#" + id);
            }
            elem.html(this.options.uploadTemplate());
            elem.dialog({
                modal: true,
                title: 'Choose file type',
                width: 400,
                height: 250,
                buttons: [
                    {
                        text: 'Cancel',
                        click: function () {
                            var top = $('body').scrollTop();
                            $(this).dialog('close');
                            $('body').scrollTop(top);
                        }
                    },
                    {
                        text: 'Upload',
                        id: 'ez-editor-file-upload-btn',
                        click: function () {
                            self.uploadContent($(this));
                        }
                    }
                ]
            });
        };
        HtmlEditor.prototype.getWordsum = function (inputs) {
            var value = inputs.val() || 0;
            var data = inputs.data('ez.wordsum');
            var count = this.counts.wordcount || this.getWordCount();
            value = +value;
            if (data[this.id]) {
                value -= +data[this.id];
            }
            if (!count) {
                count = 0;
            }
            count = +count;
            value += count;
            data[this.id] = count;
            return value;
        };
        HtmlEditor.prototype.addComment = function () {
            var comment = this.cache.comment;
            var ed = this.editor;
            var commentTempId = this.options.commentTempId;
            var wrapper = $('<span>', {
                id: commentTempId,
                class: classes.commentCls,
                html: ed.selection.getContent()
            });
            if (comment.popup) {
                this.closeComment(true);
            }
            ed.selection.setContent(wrapper.prop('outerHTML'));
            this.commentPopup();
        };
        HtmlEditor.prototype.removeConfirmation = function () {
            var self = this;
            var wrapper = getRemoveConfirmationBox();
            wrapper.html('Are you sure you want to delete comment.').dialog({
                modal: true,
                title: 'Confirmation',
                width: 450,
                height: 200,
                buttons: {
                    No: function () {
                        $(this).dialog('close');
                    },
                    Yes: function () {
                        $(this).dialog('close');
                        self.removeComment();
                    }
                }
            });
        };
        HtmlEditor.prototype.removeComment = function (threadId) {
            var ed = this.editor;
            var clearAll = this.options.clearAll;
            var node = $(ed.selection.getNode());
            if (threadId) {
                ed.dom.remove(ed.dom.select("#" + threadId), true);
            }
            else if (clearAll) {
                ed.dom.remove(ed.dom.select("." + classes.commentCls), true);
            }
            else if (node.hasClass(classes.commentCls)) {
                node.contents().unwrap();
            }
            else {
                $('<div>', {
                    html: ed.selection.getContent()
                })
                    .find("." + classes.commentCls)
                    .each(function each() {
                    var id = "#" + this.id;
                    ed.dom.remove(ed.dom.select(id), true);
                });
            }
        };
        HtmlEditor.prototype.commentPopup = function (itemId) {
            var ed = this.editor;
            var _a = this.options, commentTempId = _a.commentTempId, commentTemplate = _a.commentTemplate;
            var comment = this.cache.comment;
            var pos = posCommentPopup(ed, itemId || commentTempId);
            var context = {
                closeId: comment.close,
                edId: ed.id,
                threadId: itemId ? '' : itemId,
                left: pos.left + "px",
                top: pos.top + "px",
                list: itemId ? getCommentList(itemId).commentList : ''
            };
            var template = commentTemplate;
            if (comment.popup) {
                this.closeComment();
            }
            $('body').append(template(context));
            // eslint-disable-next-line no-unneeded-ternary
            comment.temp = itemId ? false : true;
            comment.popup = $('#edCommentPopover');
            comment.threadId = itemId;
            this.commentPopupEvents();
            if ($.ezdia.isLocalStorageEnable) {
                var commentText = localStorage.getItem(commentlocalStorage + this.name);
                $('#ez-editor-comment-textarea')
                    .val(commentText || '')
                    .focus();
            }
        };
        HtmlEditor.prototype.commentPopupEvents = function () {
            var _this = this;
            var self = this;
            var _a = this.cache.comment, save = _a.save, close = _a.close;
            var closeEventKey = "click.tinymce.comment." + this.id;
            $("#" + save).on('click', function each() {
                self.saveComment(this);
            });
            $("#" + close).on('click', function () {
                self.closeComment();
            });
            var listContainer = $('#ez-editor-comments-list');
            this.cache.comment.listContainer = listContainer;
            listContainer
                .on('click', '[data-comment="edit"]', toggleEditCommentBox.bind(this, null))
                .on('click', '[data-comment="delete"]', function (event) {
                var rowid = getCommentId(event);
                _this.confirmDelete(rowid, _this.cache.comment.threadId, false, '');
            })
                .on('click', '[data-comment="saveEdit"]', this.updateComment.bind(this))
                .on('click', '[data-comment="cancelEdit"]', toggleEditCommentBox.bind(this, null));
            this.cache.closeEventKey = closeEventKey;
            $('body')
                .off(closeEventKey)
                .on(closeEventKey, function (event) {
                var currentTarget = $(event.target);
                if (!currentTarget.closest('.ed-comments').length &&
                    !currentTarget.closest('.mce-container-body').length &&
                    !currentTarget.closest('#edCommentPopover').length &&
                    !currentTarget.closest("#" + deleteConfirmId).length) {
                    self.closeComment();
                }
            });
        };
        HtmlEditor.prototype.closeComment = function (noUpdate) {
            var popup = '';
            var commentObj = this.cache.comment;
            var ed = this.editor;
            var commentText = $('#ez-editor-comment-textarea').val();
            if (commentObj.popup) {
                var list = commentObj.listContainer.find('li');
                popup = commentObj.popup;
                if (commentObj.temp) {
                    ed.dom.remove(ed.dom.select("#" + this.options.commentTempId), true);
                }
                else if (!list.length) {
                    this.removeComment(commentObj.threadId);
                }
                popup.remove();
                commentObj.popup = '';
                commentObj.temp = false;
            }
            else {
                popup = $('#edCommentPopover');
                if (popup.length) {
                    popup.remove();
                }
            }
            if ($.ezdia.isLocalStorageEnable) {
                localStorage.setItem(commentlocalStorage + this.name, commentText || '');
            }
            $('body').off(this.cache.closeEventKey);
            if (!noUpdate) {
                setTimeout(function () {
                    ed.focus();
                    $(window).focus();
                }, 0);
            }
        };
        HtmlEditor.prototype.setCommentList = function (content) {
            var template = this.options.commentListTemplate;
            this.cache.comment.listContainer.append(template({ list: content }));
        };
        HtmlEditor.prototype.saveComment = function (button) {
            var comment = $('#ez-editor-comment-textarea').val();
            var threadId = this.cache.comment.threadId;
            if (!comment) {
                return;
            }
            var btn = $(button).button('loading');
            var self = this;
            var ed = this.editor;
            var _a = $.ezdia.config.pageParams, account = _a.account, role = _a.role;
            var selId = ezdia.util.getSelectedGridItemsByGridId();
            var data = "&accountName=" + (account || '');
            data += "&roleName=" + (role || '');
            data += "&taskId=" + selId;
            data += "&fieldName=" + $("#" + ed.id).attr('name');
            data += "&comment=" + comment;
            data += "&commentThreadId=" + (threadId || '');
            $.ajax({
                type: 'POST',
                url: 'saveComment.htm',
                data: data,
                dataType: 'json',
                success: function (response) {
                    $('#ez-editor-comment-textarea').val('');
                    btn.button('reset');
                    if (!threadId) {
                        var elem = $(ed.getBody()).find('#edCommentTempId');
                        elem.attr('id', response.threadId);
                        btn.attr('data-theard', response.threadId);
                        self.cache.comment.threadId = response.threadId;
                        self.cache.comment.temp = false;
                    }
                    self.setCommentList(response.commentList);
                },
                error: function () {
                    btn.button('reset');
                }
            });
        };
        HtmlEditor.prototype.updateComment = function (event) {
            var id = getCommentId(event);
            var threadId = this.cache.comment.threadId;
            var comment = $("#commentTextarea" + id).val();
            var data = "&commentId=" + id;
            data += "&commentThreadId=" + threadId;
            data += "&comment=" + comment;
            $.ajax({
                type: 'POST',
                url: 'editComment.htm',
                data: data,
                dataType: 'json',
                success: function () {
                    updateCommentRowView(id, comment);
                },
                error: function (response) {
                    // eslint-disable-next-line no-console
                    console.log(response);
                }
            });
        };
        HtmlEditor.prototype.confirmDelete = function (id, threadId, all, name) {
            var self = this;
            var wrapper = $.ezdia.getWrapper(deleteConfirmId);
            wrapper
                .html('Are you sure you want to delete this comment? <br /> You will not be able to reverse this action.')
                .dialog({
                modal: true,
                title: 'Choose file type',
                width: 400,
                height: 200,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function (e) {
                            e.stopPropagation();
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Delete',
                        class: 'btn-default',
                        click: function (e) {
                            e.stopPropagation();
                            self.deleteComments(id, all, name);
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        HtmlEditor.prototype.deleteComments = function (id, all, name) {
            var _a = this.cache.comment, listContainer = _a.listContainer, threadId = _a.threadId;
            var _b = $.ezdia.config.pageParams, account = _b.account, role = _b.role;
            var selId = ezdia.util.getSelectedGridItemsByGridId();
            var data = "&accountName=" + (account || '');
            data += "&roleName=" + (role || '');
            data += "&taskId=" + selId;
            data += "&fieldName=" + name;
            data += "&commentId=" + id;
            data += "&commentThreadId=" + threadId;
            data += "&clearAll=" + all;
            $.ajax({
                type: 'POST',
                url: 'deleteComments.htm',
                data: data,
                dataType: 'json',
                success: function () {
                    listContainer.find("#" + id).remove();
                }
            });
        };
        HtmlEditor.prototype.getContent = function (selection, optionsProps) {
            var content = '';
            var options = optionsProps || {};
            if (options.ez_keyword) {
                content = this.options.inlineContentContainer.find('[data-ez-editable]');
            }
            else if (this.options.inline) {
                content = this.elem.value;
            }
            else if (selection) {
                content = this.editor.selection.getContent(options);
            }
            else {
                content = this.editor.getContent(options);
            }
            return content;
        };
        /*
         * languagetool
         */
        HtmlEditor.prototype.getltText = function () {
            var obj = {
                text: '',
                html: ''
            };
            var self = this;
            var ed = this.editor;
            var content = '';
            var blockElements = this.options.blockElements;
            var body = ed.getBody();
            var $body = $('<body>', {
                html: this.ltClearHighlighter(body.innerHTML)
            });
            var uuid;
            this.ltTextObj = {};
            $.each($body[0].childNodes, function each() {
                uuid = getUUID();
                var isBlock = blockElements.includes(this.nodeName.toLowerCase());
                if (isBlock && obj.text) {
                    content += obj.text + "\t(" + uuid + ")\n\n";
                    self.ltTextObj[uuid] = obj.html;
                    obj = {
                        text: '',
                        html: ''
                    };
                    uuid = getUUID();
                }
                else if (obj.text &&
                    (this.nodeName === 'BR' || this.nodeName === 'HR')) {
                    obj.text += '\n';
                    obj.html += "<" + this.nodeName.toLowerCase() + ">";
                }
                else if (!isBlock) {
                    obj.text +=
                        this.nodeType === 3
                            ? this.data
                            : this.innerText;
                    obj.html +=
                        this.nodeType === 3
                            ? this.data
                            : this.outerHTML;
                }
                if (isBlock) {
                    content += this.innerText + "\t(" + uuid + ")\n\n";
                    self.ltTextObj[uuid] = this.outerHTML;
                }
            });
            if (obj.text) {
                content += obj.text + "\t(" + uuid + ")\n\n";
                self.ltTextObj[uuid] = obj.html;
            }
            return content;
        };
        HtmlEditor.prototype.ltErrors = function (obj) {
            var _this = this;
            var self = this;
            if (this.options.inline) {
                this.cache.ltIgnoreList = this.getIgnoreList();
            }
            $.each(obj.res.matches, function (i, o) {
                var item = o;
                var mytext = obj.text;
                var tempstr = mytext.substr(item.offset);
                var tempword = tempstr.substr(0, item.length);
                var uuid;
                var templen;
                var hclass = ltSetHighlight.other;
                if (ltSetHighlight[item.rule.issueType] !== undefined) {
                    hclass = ltSetHighlight[item.rule.issueType];
                }
                tempstr.replace(/(?:^|\n)(.*?\t)\(([a-f0-9-]{36})\)\n/, function (pmatch, p1, p2) {
                    uuid = p2;
                    return pmatch;
                });
                mytext.replace(new RegExp(".*\\([a-f0-9-]{36}\\)(?:\n\n)([^\\t]+?\\t\\(" + uuid + "\\))\n\n"), function (pmatch, p1) {
                    templen = mytext.indexOf(p1);
                    return pmatch;
                });
                item.offset -= templen || 0;
                if (!self.ltTextObj[uuid]) {
                    return;
                }
                self.ltTextObj[uuid] = _this.ltApplyHighlighter.call(self, self.ltTextObj[uuid], i, tempword, item.rule.id, hclass, item.offset, item.offset + item.length);
            });
        };
        HtmlEditor.prototype.ltApplyHighlighter = function (myobj, myid, myword, myrule, myclass, start, end) {
            var mystart = start;
            var myend = end;
            var myhtml = ltText(myobj);
            if (this.cache.ltIgnoreList.includes(myword)) {
                return myhtml;
            }
            // eslint-disable-next-line no-useless-escape
            var patt = /(\<.*?\>)|&(?:nbsp|amp|quot|copy|reg|[gl]t|\#[0-9a-f]+);/gi;
            var match;
            // eslint-disable-next-line no-cond-assign
            while ((match = patt.exec(myhtml))) {
                var topt = void 0;
                if (match[0].substr(0, 3) === '<br') {
                    topt = patt.lastIndex - match.index - 1;
                }
                else if (match[0].substr(0, 1) === '<' ||
                    myrule === 'WHITESPACE_RULE') {
                    topt = patt.lastIndex - match.index;
                }
                else {
                    topt = patt.lastIndex - match.index - 1;
                }
                if (mystart >= match.index) {
                    mystart += topt;
                }
                if (myend > match.index) {
                    myend += topt;
                }
            }
            var myspan = "<span class=\"lt-highlight " + myclass + "\" data-hid=\"" + myid + "\" data-word=\"" + window.btoa(encodeURIComponent(myword)) + "\" data-rule=\"" + myrule + "\">";
            myhtml = insertAt(myhtml, myspan, mystart);
            myhtml = insertAt(myhtml, '</span>', myend + myspan.length);
            var ddup = new RegExp('</(EM|STRONG|SUP|SUB)><\\1>', 'i');
            myhtml = myhtml.replace(ddup, '');
            return myhtml;
        };
        HtmlEditor.prototype.ltSetContent = function () {
            var self = this;
            var content = '';
            $.each(self.ltTextObj, function each() {
                if (this.nodeName === 'BR') {
                    content += '<br>';
                }
                else if (this.nodeName === 'HR') {
                    content += '<hr>';
                }
                else {
                    content += this;
                }
            });
            this.editor.setContent(content);
        };
        HtmlEditor.prototype.ltContextMenu = function (element) {
            var self = this;
            var ltCMTemplate = this.options.ltContextMenuTemplate;
            var elem = $(element);
            var index = elem.data('hid');
            var matche = this.cache.lt.matches[index];
            var pos = posCommentPopup(this.editor, elem);
            var win = $(window);
            var body = $(this.editor.getBody());
            var menu = ltCMTemplate({
                pos: pos,
                description: matche.rule.description,
                replacements: matche.replacements
            });
            menu = $(menu);
            menu.on('click', '[data-replacements]', function each() {
                var type = $(this).data('replacements');
                if (type === 'ignore') {
                    var ignoreText = elem.text();
                    if ($.ezdia.isLocalStorageEnable) {
                        self.addToIgnoreList(ignoreText);
                    }
                    elem.replaceWith(ignoreText);
                }
                else {
                    elem.replaceWith(this.innerHTML);
                }
                menu.remove();
            });
            if (this.cache.lt.menu) {
                this.cache.lt.menu.remove();
            }
            this.cache.lt.menu = menu;
            $('body').append(menu);
            win.on('click.ez..lt.context.menu', this.ltHideContextMenu.bind(this, win));
            body.on('click.ez.lt.context.menu', this.ltHideContextMenu.bind(this, win));
        };
        HtmlEditor.prototype.ltHideContextMenu = function (win, e) {
            var isNode = $(e.target).closest('.lt-highlight').length;
            if (!isNode) {
                this.cache.lt.menu.remove();
                win.off('.ez.lt.context.menu');
                $(this.editor.getBody()).off('.ez.lt.context.menu');
            }
        };
        HtmlEditor.prototype.abortlt = function () {
            var ed = this.editor;
            var bookmark = $(ed.getBody()).find('#lt-bookmark');
            ed.selection.select(bookmark[0]);
            ed.selection.getRng(1).collapse(0);
            bookmark.remove();
            ed.settings.lt_isdirty = true;
            this.cache.inputContainer.removeClass(ltLoadingCls);
            $('body').removeClass(ltLoadingBodyCls);
            ed.setMode('design');
        };
        HtmlEditor.prototype.addToIgnoreList = function (ignoreText) {
            this.cache.ltIgnoreList.push(ignoreText);
            localStorage[this.cache.ltLocalStorageKey] = JSON.stringify(this.cache.ltIgnoreList);
        };
        HtmlEditor.prototype.getIgnoreList = function () {
            var list = localStorage[this.cache.ltLocalStorageKey];
            if (list) {
                list = $.ezdia.getJsonObject(list);
            }
            else {
                list = [];
            }
            return list;
        };
        HtmlEditor.prototype.ltIgnoreListSetup = function () {
            var _this = this;
            var _a = $.ezdia.config.pageParams, account = _a.account, role = _a.role;
            this.cache.ltLocalStorageKey = (function () {
                var arr = ['ezdia.lt'];
                if (account) {
                    arr.push(account);
                }
                if (role) {
                    arr.push(role);
                }
                arr.push(_this.options.field_name);
                return arr.join('.');
            })();
            this.cache.ltIgnoreList = this.getIgnoreList();
        };
        return HtmlEditor;
    }());
    // PRIVATE FUNCTIONS
    // =========================
    var lut = [];
    for (var i = 0; i < 256; i++) {
        lut[i] = (i < 16 ? '0' : '') + i.toString(16);
    }
    var getUUID = function () {
        // tslint:disable-next-line:no-bitwise
        var d0 = (Math.random() * 0xffffffff) | 0;
        // tslint:disable-next-line:no-bitwise
        var d1 = (Math.random() * 0xffffffff) | 0;
        // tslint:disable-next-line:no-bitwise
        var d2 = (Math.random() * 0xffffffff) | 0;
        // tslint:disable-next-line:no-bitwise
        var d3 = (Math.random() * 0xffffffff) | 0;
        // tslint:disable-next-line:no-bitwise
        return lut[d0 & 0xff] +
            lut[(d0 >> 8) & 0xff] +
            lut[(d0 >> 16) & 0xff] +
            lut[(d0 >> 24) & 0xff] + "-" + lut[d1 & 0xff] + lut[(d1 >> 8) & 0xff] + "-" + lut[((d1 >> 16) & 0x0f) | 0x40] + lut[(d1 >> 24) & 0xff] + "-" + lut[(d2 & 0x3f) | 0x80] + 
        // tslint:disable-next-line:no-bitwise
        lut[(d2 >> 8) & 0xff] + "-" + lut[(d2 >> 16) & 0xff] + lut[(d2 >> 24) & 0xff] + lut[d3 & 0xff] + lut[(d3 >> 8) & 0xff] + lut[(d3 >> 16) & 0xff] + lut[(d3 >> 24) & 0xff];
    };
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        updateCharCount: HtmlEditor.prototype.updateCharCount,
        updateWordCount: HtmlEditor.prototype.updateWordCount,
        updateSelectedCount: HtmlEditor.prototype.updateSelectedCount,
        updateKeywordsCount: HtmlEditor.prototype.updateKeywordsCount,
        clearBadContent: HtmlEditor.prototype.clearBadContent,
        uploadContent: HtmlEditor.prototype.uploadContent,
        msWordContent: HtmlEditor.prototype.msWordContent,
        setHeight: HtmlEditor.prototype.setHeight,
        updateWordsum: HtmlEditor.prototype.updateWordsum,
        toggle: HtmlEditor.prototype.toggle,
        comment: HtmlEditor.prototype.comment,
        languagetool: HtmlEditor.prototype.languagetool,
        createLtLoading: HtmlEditor.prototype.createLtLoading,
        clean: HtmlEditor.prototype.clean
        // refresh: HtmlEditor.prototype.refresh,
        // destroy : HtmlEditor.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof HtmlEditor) {
            return inputObject;
        }
        return undefined;
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new HtmlEditor(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = HtmlEditor;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
